import React from 'react';
import PropTypes from 'prop-types';
import {
    Dialog, DialogContent, makeStyles,
} from '@material-ui/core';
import GeneralUtils from 'utils/GeneralUtils';
import DialogAppBar from 'components/widgets/modal/DialogAppBar';

const useStyle = makeStyles((theme = {}) => ({
    AppBar: {
        color: theme.palette.text.white,
        backgroundColor: theme.palette.background.sanMarino,
        '& h4': {
            color: theme.palette.text.white,
        },
    },
    content: {
        padding: '20px 10px',
        overflowX: 'hidden',
        fontSize: '14px',
        whiteSpace: 'pre-wrap',
        [theme.breakpoints.down('sm')]: {
            paddingLeft: 0,
            paddingRight: 0,
        },
    },
}));

const ADFViewer = ({ adf, toggleViewer }) => {
    const classes = useStyle();

    return (
        <Dialog
            open
            fullWidth
            maxWidth="md"
            disableBackdropClick
            disableEscapeKeyDown
            scroll="paper"
            onMouseDown={(e) => e.stopPropagation()}
        >
            <DialogAppBar
                appBarClassName={classes.AppBar}
                title="ADF XML Viewer"
                onClose={() => toggleViewer()}
                toolbarSize="md"
            />
            <DialogContent>
                <div className={classes.content}>
                    {GeneralUtils.formatRawXML(adf)}
                </div>
            </DialogContent>
        </Dialog>
    );
};

ADFViewer.propTypes = {
    adf: PropTypes.string.isRequired,
    toggleViewer: PropTypes.func.isRequired,
};

export default ADFViewer;
